import { render, staticRenderFns } from "./NewUiAlerts.vue?vue&type=template&id=f11d90e8&"
import script from "./NewUiAlerts.vue?vue&type=script&lang=ts&"
export * from "./NewUiAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports